import { ResourceOptions } from 'react-admin';
import { FaUserCheck } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxUserRewardSummary;
export const icon = FaUserCheck;
export const options: ResourceOptions = {
  label: 'module.blindBox.userRewardSummary',
};

